import { LoginForm } from "@/components/auth/LoginForm";
import Image from "next/image";

const Login = () => {
  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Background accents */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(1200px_600px_at_-10%_-10%,hsl(var(--primary)/0.12),transparent),radial-gradient(900px_500px_at_110%_110%,hsl(var(--accent)/0.1),transparent)]" />
      <div className="relative z-10 flex min-h-screen">
        {/* Brand panel */}
        <div className="hidden lg:flex w-1/2 flex-col justify-center px-20 gap-8 bg-gradient-to-br from-background to-card/70 border-r">
          <div className="max-w-lg">
            <Image src="/logo.svg" alt="Smart Taurus" width={220} height={66} className="mb-8" priority />
            <h1 className="text-3xl font-semibold tracking-tight text-foreground">Welcome back</h1>
            <p className="mt-3 text-base text-foreground/80 leading-relaxed">
              Sign in to manage quotes, track jobs in real time, and get paid fast.
            </p>
          </div>
        </div>
        {/* Auth panel */}
        <div className="flex w-full lg:w-1/2 items-center justify-center px-6 py-12">
          {/* Gradient outline wrapper */}
          <div className="w-full max-w-lg rounded-3xl p-[1px] bg-gradient-to-br from-primary/25 via-muted-foreground/10 to-primary/25">
            <div className="rounded-3xl border border-border/60 bg-card p-8 shadow-lg shadow-primary/5 backdrop-blur supports-[backdrop-filter]:bg-card/95">
              <div className="mb-8 text-center lg:hidden">
                <Image src="/logo.svg" alt="Smart Taurus" width={180} height={52} className="mx-auto mb-4" />
                <h2 className="text-2xl font-semibold tracking-tight">Sign in</h2>
                <p className="text-sm text-foreground/80 mt-1">Welcome back — let’s get you moving</p>
              </div>
              <div className="mb-6 hidden lg:block">
                <h2 className="text-xl font-medium tracking-tight text-foreground">Sign in to your account</h2>
                <p className="text-sm text-foreground/80 mt-1">Use your email and password to continue</p>
              </div>
              <div className="space-y-6">
                <LoginForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;